const PANELS = {
    ProjectDatasets(vm) {
        if (vm.isDatasetInfoDrawer) {
            return {
                component: 'ProjectDatasetInfoDrawerPanel',
                props: {
                    dataset: vm.datasetDrawerDataset,
                },
                on: {},
            }
        }
        return {
            component: 'ProjectDatasetsDrawerPanel',
            props: {
                disabled: vm.isProjectArchived,
                search: vm.drawerSearch,
                sortBy: vm.datasetsSortBy,
                sortDirection: vm.datasetsSortDirection,
                sortOptions: vm.datasetsSortOptions,
                sortDirectionOptions: vm.sortDirectionOptions,
            },
            on: {
                create: vm.handleCreate,
                'apply-search': vm.applySearch,
                'apply-sort': vm.applyDatasetsSort,
                'update:search': (value) => vm.handleDrawerSearchUpdate(value),
                'update:sortBy': (value) => vm.handleDatasetsSortByUpdate(value),
                'update:sortDirection': (value) => vm.handleDatasetsSortDirectionUpdate(value),
            },
        }
    },
    ProjectModels(vm) {
        if (vm.isModelInfoDrawer) {
            return {
                component: 'ProjectModelInfoDrawerPanel',
                props: {
                    model: vm.modelDrawerModel,
                },
                on: {
                    preview: vm.handleModelPreview,
                },
            }
        }
        return {
            component: 'ProjectModelsDrawerPanel',
            props: {
                disabled: vm.isProjectArchived,
                search: vm.drawerSearch,
                sortBy: vm.modelsSortBy,
                sortDirection: vm.modelsSortDirection,
                sortOptions: vm.modelsSortOptions,
                sortDirectionOptions: vm.sortDirectionOptions,
            },
            on: {
                create: vm.handleCreate,
                'apply-search': vm.applySearch,
                'apply-sort': vm.applyModelsSort,
                'update:search': (value) => vm.handleDrawerSearchUpdate(value),
                'update:sortBy': (value) => vm.handleModelsSortByUpdate(value),
                'update:sortDirection': (value) => vm.handleModelsSortDirectionUpdate(value),
            },
        }
    },
}

export const projectContextDrawerRoutes = Object.freeze(Object.keys(PANELS))

export function getProjectContextDrawerPanel(vm) {
    const factory = PANELS[vm.routeName]
    if (!factory) return { component: null, props: {}, on: {} }
    return factory(vm)
}
